var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideMultileLineDarkBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Navigation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#2e4d7b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75095",
    "data-name": "Group 75095",
    transform: "translate(-14437.385 4977.813)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_9576",
    "data-name": "Line 9576",
    y1: 10.019,
    x2: 6.936,
    transform: "translate(14442.239 -4972.532)",
    fill: "none",
    stroke: "#f5f6f8",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9574",
    "data-name": "Line 9574",
    x2: 6.165,
    y2: 10.019,
    transform: "translate(14449.946 -4970.991)",
    fill: "none",
    stroke: "#f5f6f8",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6647",
    "data-name": "Ellipse 6647",
    cx: 2.996,
    cy: 2.996,
    r: 2.996,
    transform: "translate(14446.389 -4976)",
    fill: "#f5f6f8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9575",
    "data-name": "Line 9575",
    x2: 11.56,
    y2: 1.541,
    transform: "translate(14443.78 -4960.201)",
    fill: "none",
    stroke: "#f5f6f8",
    strokeLinecap: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6646",
    "data-name": "Ellipse 6646",
    cx: 2.996,
    cy: 2.996,
    r: 2.996,
    transform: "translate(14454.778 -4961.619)",
    fill: "#f5f6f8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6648",
    "data-name": "Ellipse 6648",
    cx: 2.996,
    cy: 2.996,
    r: 2.996,
    transform: "translate(14438 -4964.016)",
    fill: "#f5f6f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideMultileLineDarkBackground);
export default __webpack_public_path__ + "static/media/HideMultileLineDarkBackground.38ef366c4f7576134b247316183f3543.svg";
export { ForwardRef as ReactComponent };